<template>
  <div :class="{ faded: disabled }" :title="disabled ? `${$t('Coming soon')}!` : ''">
    <div class="row markets-row">
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <MarketInputGroup
        :id="marketAbbreviation"
        :disabled="disabled"
        :mandatory="mandatory"
        :input-name="`markets`"
        :is-selected="isSelected"
        :show-options="!showRegionalSettings"
        :is-onsite-selected="isOnsite"
        :is-remote-selected="isRemote"
        :hide-site-selections="hideSiteSelections"
        @toggle-selected="toggleMarket"
        @toggle-onsite-selected="toggleMarketOnsite"
        @toggle-remote-selected="toggleMarketRemote"
      >
        <strong>{{ $t(title) }}</strong>
      </MarketInputGroup>
    </div>

    <div v-show="isSelected" v-if="regions.length" class="row indented-section">
      <div class="p-l-10">
        <div v-show="showRegionalSettings" class="row">
          <div v-for="region in regions" :key="region.id" class="row">
            <MarketInputGroup
              :id="region.id"
              :input-name="`markets[${marketAbbreviation}][regions]`"
              :is-selected="region.isSelected && isSelected"
              :is-onsite-selected="region.isOnsite"
              :is-remote-selected="region.isRemote"
              :mandatory="region.isSelected && numberOfRegionsSelected < 2"
              :hide-site-selections="hideSiteSelections"
              @toggle-selected="toggleRegion"
              @toggle-onsite-selected="toggleRegionOnsite"
              @toggle-remote-selected="toggleRegionRemote"
            >
              {{ $t(region.name) }}
            </MarketInputGroup>
          </div>
        </div>
        <div class="row">
          <a href="#" @click="toggleRegionalSettings">
            <small>
              {{
                showRegionalSettings
                  ? `${$t('Cancel custom regional settings')}`
                  : `${$t('Specify custom regional settings')}`
              }}
            </small>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketInputGroup from '@/components/MarketInputGroup.vue'

export default {
  components: { MarketInputGroup },
  props: {
    title: { type: String, required: true },
    marketAbbreviation: { type: String, required: true },
    isSelected: { type: Boolean, required: true },
    isRemote: { type: Boolean, required: true },
    isOnsite: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    mandatory: { type: Boolean, default: false },
    regions: { type: Array, required: true },
    hideSiteSelections: { type: Boolean, required: false },
  },
  data() {
    return {
      regionalSettingsSelected: false,
    }
  },
  computed: {
    showRegionalSettings() {
      return this.regionalSettingsSelected
    },
    numberOfRegionsSelected() {
      return this.regions.filter((region) => region.isSelected).length
    },
  },
  created() {
    this.regionalSettingsSelected = this.numberOfRegionsSelected > 0
  },
  methods: {
    toggleRegionalSettings() {
      this.toggleAllRegions(!this.regionalSettingsSelected)
      this.regionalSettingsSelected = !this.regionalSettingsSelected
    },
    toggleMarket(value, isSelected) {
      this.$emit('toggle-market', value, isSelected)
    },
    toggleMarketOnsite(value, isSelected) {
      this.$emit('toggle-market-onsite', value, isSelected)
    },
    toggleMarketRemote(value, isSelected) {
      this.$emit('toggle-market-remote', value, isSelected)
    },
    toggleRegion(regionId, isSelected) {
      this.$emit('toggle-region', this.marketAbbreviation, regionId, isSelected)
    },
    toggleRegionOnsite(regionId, isSelected) {
      this.$emit('toggle-region-onsite', this.marketAbbreviation, regionId, isSelected)
    },
    toggleRegionRemote(regionId, isSelected) {
      this.$emit('toggle-region-remote', this.marketAbbreviation, regionId, isSelected)
    },
    toggleAllRegions(enable) {
      this.regions.forEach((region) => this.toggleRegion(region.id, enable))
    },
  },
}
</script>

<style scoped lang="scss">
.indented-section {
  padding: 5px 15px;
  margin: 0 0 5px;
  border-left: 5px solid #eeeeee;
  @media (min-width: 768px) {
    padding: 10px 20px;
    margin: 0 0 20px;
  }
}
</style>
